module.exports = __webpack_public_path__ + "static/media/DqEveryChildExhibitionPhoto1.49cce01a.jpg";